<script>
import { mapState } from 'vuex';
import PaymentTable from './SupplierPaymentsPaymentTable';
import AccumulationTable from './SupplierPaymentsAccumulationTable';

export default {
  name: 'TableContainer',
  components: {
    PaymentTable,
    AccumulationTable,
  },
  computed: {
    ...mapState({
      radio: state => state.supplierPayments.filter.data.selectedTableType,
      selectedBrands: state => state.supplierPayments.filter.data.selectedBrands,
      availableBrands: state => state.supplierPayments.filter.data.availableBrands,
    }),
  },
  filters: {
    formatNumber: number => Math.round(number)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
  },
};
</script>

<template>
  <v-container class="pa-0 ma-0">
    <v-layout>
      <v-flex v-if="radio === 3">
        <Payment-table/>
      </v-flex>
      <v-flex v-else xs12>
        <accumulation-table @refresh="$emit('refresh')"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/payments/supplier-payments/SupplierPaymentsTableContainer.vue